import { useInjection } from "@linkfluence/core/di";
import {
  UserRepo,
  UserRepositoryUID,
} from "@linkfluence/core/user/repositories/UserRepo";
import { User } from "@linkfluence/models/user";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useDeleteUserPicture(user: User) {
  const repository = useInjection<UserRepo>(UserRepositoryUID);
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation(
    (data: { picture: number }) => {
      return repository.deleteUserPicture(user.id, data.picture);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["/user/avatars"]);
      },
    }
  );
  return async (picture: number) => {
    await mutateAsync({ picture });
  };
}
